<template>
  <div>
      <section class="mainContainer">
            <div class="row">
                <!-- Left Side -->
                <div class="col-lg-3 col-12 p-0">
                    <div class="leftContainer">
                        <div class="leftContainer__title">
                            <h3>Hi {{user ? user.firstName : '***'}},</h3>
                            <p>Welcome to Your Dashboard</p>
                        </div>
                        <!-- View crops -->
                        <div class="leftContainer__crops">
                            <div class="leftContainer__crops__header d-flex borderBottom py-3 mt-3">
                                <h4>My Crops  </h4>
                                <!-- <a href="#" class=" text-right">View all</a> -->
                            </div>
                            <crop-row v-for="(crop, index) in crops" :key="index" :crop="crop" :length="crops.length" :index="index" />

                            <h5 class=" margin_top_md">
                                <router-link :to="{ name: 'offtaker.mycrops' }" class=" font-bold color__green">View all</router-link>
                            </h5>

                            <!-- <div class="harvest--due d-flex justify-content-between align-items-center">
                                <div class="d-flex align-items-center">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M19.732 12.4543C19.6835 12.4878 19.3487 12.7227 18.8821 13.1001C18.8105 9.60964 17.683 4.85388 15.6961 4.85388C13.7093 4.85388 12.5819 9.60947 12.5103 13.1003C12.0437 12.7225 11.7089 12.4876 11.6605 12.4542L10.4375 11.6057L10.9004 13.0205C10.9059 13.0372 11.4456 14.7097 11.4456 16.7345C11.4456 19.144 13.0871 21.104 15.1053 21.104H16.287C18.3046 21.104 19.9464 19.1438 19.9464 16.7345C19.9464 14.7097 20.4864 13.0372 20.4915 13.0208L20.9584 11.603L19.732 12.4543ZM13.5142 12.9241C13.5272 12.477 13.5555 12.0376 13.5978 11.6103H14.3692V10.6109H13.7241C13.8041 10.088 13.903 9.59232 14.0146 9.13058H14.8716V8.13116H14.2924C14.7369 6.73946 15.2837 5.85314 15.6963 5.85314C16.3193 5.85314 17.2497 7.87764 17.6685 10.6109H17.3675V11.6103H17.7946C17.8369 12.0374 17.8652 12.477 17.8782 12.9241H17.0915V13.9235H17.8782C17.8775 13.9408 17.8769 13.9576 17.8765 13.9746C17.0837 14.7157 16.2225 15.6622 15.6961 16.6641C15.1694 15.662 14.3083 14.716 13.5157 13.9746C13.5154 13.9576 13.5147 13.9408 13.5141 13.9235H14.0932V12.9241H13.5142ZM18.9471 16.7347C18.9471 18.593 17.7541 20.1048 16.2871 20.1048H15.1055C13.6385 20.1048 12.4452 18.593 12.4452 16.7347C12.4452 15.7411 12.3281 14.8361 12.1973 14.1365C13.5152 15.2561 15.1966 17.0129 15.1966 18.4414H16.196C16.196 17.0129 17.877 15.2561 19.195 14.1365C19.0645 14.836 18.9471 15.7411 18.9471 16.7347Z"
                                            fill="#F2950A" />
                                        <path d="M16.8708 8.13123H15.8713V9.13065H16.8708V8.13123Z" fill="#F2950A" />
                                        <path d="M16.3683 10.611H15.3689V11.6104H16.3683V10.611Z" fill="#F2950A" />
                                        <path d="M16.0922 12.9241H15.0928V13.9235H16.0922V12.9241Z" fill="#F2950A" />
                                        <path
                                            d="M7.62395 5.74994L8.8056 4.56829L8.09901 3.8617L7.00747 4.95323V2.89575H6.00805V4.95323L4.91618 3.86103L4.20959 4.56762L5.3974 5.75577C3.73986 6.18036 3.04126 7.70348 3.04126 10.7119C3.04126 12.7394 3.3744 15.0246 3.93275 16.8246C4.40148 18.3363 5.22883 20.1386 6.50776 20.1385C7.78669 20.1385 8.61371 18.3362 9.08211 16.8244C9.64046 15.0243 9.97326 12.7396 9.97326 10.7121C9.9736 8.71423 9.66094 7.40732 8.9895 6.59978C8.59089 6.12039 8.10801 5.8742 7.62395 5.74994ZM8.12749 16.5286C7.56865 18.3319 6.91103 19.1391 6.5076 19.1391C6.10383 19.1391 5.44637 18.3319 4.88703 16.5286C4.41563 15.0076 4.11364 13.1194 4.05251 11.36H5.34443V10.3606H4.04435C4.05151 10.0378 4.06867 9.7448 4.09382 9.47546H6.11682V8.47603H4.25023C4.68415 6.6311 5.70906 6.62877 6.50776 6.62843C7.3641 6.62843 7.86048 6.8055 8.22094 7.23875C8.72065 7.8399 8.97401 9.00856 8.97384 10.7121C8.97384 12.6443 8.65752 14.8189 8.12749 16.5286Z"
                                            fill="#F2950A" />
                                        <path d="M6.97999 10.3605H5.96924V11.3599H6.97999V10.3605Z" fill="#F2950A" />
                                    </svg>
                                    <div class="harvest--due--text">
                                        <p>Next harvest due</p>
                                        <p v-if="calendarStats">
                                            {{ calendarStats.nextHarvest | formatDate('ll')}}
                                        </p>
                                    </div>
                                </div>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893C6.90237 0.683417 6.90237 1.31658 7.29289 1.70711L12.5858 7H1C0.447715 7 0 7.44772 0 8C0 8.55229 0.447715 9 1 9H12.5858L7.29289 14.2929C6.90237 14.6834 6.90237 15.3166 7.29289 15.7071C7.68342 16.0976 8.31658 16.0976 8.70711 15.7071L15.7071 8.70711C16.0976 8.31658 16.0976 7.68342 15.7071 7.29289L8.70711 0.292893Z"
                                        fill="#F2950A" />
                                </svg>
                            </div> -->
                        </div>

                        
                        
                    </div>
                </div>

                <!-- Right Side -->
                <div class="col-lg-9 p-0">
                    <div class="rightContainer">
                        
                        <div class="row mb-4">
                            <div class="col-lg-6">
                                <h2 class=" font-bold font-xl">Dashboard</h2>
                            </div>
                        </div>

                        <!-- Cards -->
                        <div class="row mt-2">
                            <div class="col-lg-4 rightContainer__card">
                                <div class="smallCard">
                                    <div class="row">
                                        <div class="col-8">
                                            <p>Order Placed</p>
                                            <h4>{{ stats ? stats.totalOrders : ''}} <small class="smallFont">orders</small></h4>
                                        </div>
                                        <div class="col-4 d-flex justify-content-end align-content-end">
                                            <div class="rightContainer__card__svg bg__new">
                                                
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M9.79192 8.63644H4.03427C3.76499 8.63644 3.54957 8.85187 3.54957 9.12114V14.8788C3.54957 15.1481 3.76499 15.3635 4.03427 15.3635H9.79192C10.0612 15.3635 10.2766 15.1481 10.2766 14.8788V9.12114C10.2766 8.85187 10.0612 8.63644 9.79192 8.63644ZM9.30722 14.3941H4.51897V9.60584H9.30722V14.3941Z"
                                                        fill="#565009" />
                                                    <path
                                                        d="M4.03427 24H9.79192C10.0612 24 10.2766 23.7846 10.2766 23.5153V21.1212H19.9657C20.235 21.1212 20.4504 20.9057 20.4504 20.6365V3.2607C20.4504 2.99142 20.235 2.776 19.9657 2.776H13.836L14.8348 1.77722C15.0257 1.58628 15.0257 1.28273 14.8348 1.09178C14.6438 0.900842 14.3403 0.900842 14.1493 1.09178L12.3231 2.91798C12.1322 3.10892 12.1322 3.41247 12.3231 3.60341L14.1493 5.42961C14.2423 5.52263 14.3696 5.57159 14.492 5.57159C14.6144 5.57159 14.7417 5.52263 14.8348 5.42961C15.0257 5.23866 15.0257 4.93511 14.8348 4.74417L13.836 3.7454H19.481V20.1518H10.2766V17.7576C10.2766 17.4884 10.0612 17.2729 9.79192 17.2729H4.03427C3.76499 17.2729 3.54957 17.4884 3.54957 17.7576V23.5153C3.54957 23.7797 3.76989 24 4.03427 24ZM4.51897 18.2423H9.30722V23.0306H4.51897V18.2423Z"
                                                        fill="#565009" />
                                                    <path
                                                        d="M10.2766 0.4847C10.2766 0.215422 10.0612 0 9.79192 0H4.03427C3.76499 0 3.54957 0.215422 3.54957 0.4847V6.24235C3.54957 6.51163 3.76499 6.72705 4.03427 6.72705H9.79192C10.0612 6.72705 10.2766 6.51163 10.2766 6.24235V0.4847ZM9.30722 5.75765H4.51897V0.9694H9.30722V5.75765Z"
                                                        fill="#565009" />
                                                </svg>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 rightContainer__card">
                                <div class="smallCard">
                                    <div class="row">
                                        <div class="col-8">
                                            <p>Registered farmers</p>
                                            <h4>{{ stats ? stats.totalFarmers : ''}} <small class="smallFont">farmers</small></h4>
                                        </div>
                                        <div class="col-4 d-flex justify-content-end align-content-end">
                                            <div class="rightContainer__card__svg bg__new1">
                                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0)">
                                                        <path
                                                            d="M17.7867 15.5807L17.7167 15.5522C16.94 15.2183 16.1284 14.9742 15.2992 14.8215C15.0627 14.7795 14.832 14.9278 14.7692 15.1659L14.1006 17.6696L12.4306 15.8008C12.2554 15.6061 11.962 15.5956 11.7751 15.7723C11.7634 15.7813 11.7547 15.7903 11.7474 15.8008L10.0788 17.6696L9.40432 15.1599C9.34009 14.9218 9.10943 14.7736 8.8744 14.817C8.04521 14.9682 7.23353 15.2138 6.45544 15.5462L6.38537 15.5762C5.06421 16.1272 3.93283 17.0676 3.13137 18.2805C1.39708 20.9879 2.07737 24.122 2.10364 24.2493C2.15474 24.4694 2.3489 24.6236 2.56933 24.6176H21.6305C21.8524 24.6236 22.0451 24.4694 22.0962 24.2493C22.1254 24.116 22.8086 20.9879 21.0685 18.2805C20.2612 17.0646 19.1181 16.1257 17.7867 15.5807ZM17.1123 21.208H16.3415V16.0479C16.6101 16.1287 16.8656 16.2201 17.1123 16.3204V21.208ZM9.39848 18.7522C9.4671 19.0053 9.72257 19.155 9.9722 19.0846C10.0554 19.0607 10.1299 19.0128 10.1897 18.9484L12.0861 16.825L13.9839 18.9484C14.1576 19.1415 14.4525 19.1535 14.6408 18.9753C14.705 18.9139 14.7517 18.8361 14.7751 18.7522L15.4116 16.3683V21.208H8.76199V16.3683L9.39848 18.7522ZM7.07441 16.3204C7.32113 16.2201 7.57806 16.1287 7.84667 16.0479V21.208H7.05981L7.07441 16.3204ZM3.90363 18.7852C4.47005 17.9256 5.23355 17.2248 6.13135 16.7427V23.6728H2.94597C2.69926 21.9792 3.03794 20.2496 3.90363 18.7852ZM7.05981 23.6488V22.1618H17.1123V23.6728L7.05981 23.6488ZM21.2218 23.6488H18.0437V16.7681C18.9327 17.2428 19.6948 17.9361 20.2612 18.7852C21.1298 20.2481 21.4758 21.9762 21.2364 23.6728L21.2218 23.6488Z"
                                                            fill="#23331A" />
                                                        <path
                                                            d="M12.0861 0C7.51098 0 6.66573 2.70884 6.48033 5.13167C4.18254 5.39821 2.09204 5.90884 2.09204 6.88066C2.09204 7.21609 2.09204 8.05015 5.99128 8.56527C5.74457 9.13878 5.72121 9.78716 5.92559 10.3786C6.07595 10.8698 6.365 11.3071 6.75332 11.632C7.03507 11.8656 7.38689 11.9929 7.74893 11.9884C8.67886 13.8976 10.3168 15.0791 12.0861 15.0791C13.8584 15.0791 15.4934 13.9066 16.4248 11.9884C16.7868 11.9944 17.1401 11.8686 17.4189 11.632C17.8102 11.3041 18.0992 10.8668 18.2467 10.3727C18.4525 9.78267 18.4292 9.13429 18.1824 8.56077C22.0831 8.04117 22.0831 7.2071 22.0831 6.87767C22.0831 5.92381 19.9897 5.39372 17.6934 5.12568C17.5167 2.70884 16.6627 0 12.0861 0ZM12.0861 0.953859C15.47 0.953859 16.4627 2.46177 16.7357 4.7693C13.6409 4.52522 10.5329 4.52522 7.43653 4.7693C7.70806 2.46476 8.68323 0.953859 12.0861 0.953859ZM17.3635 10.0866C17.273 10.3981 17.0949 10.6781 16.8511 10.8893C16.7255 11.0046 16.5562 11.0585 16.3883 11.0345L16.3416 11.0121C16.1065 10.9027 15.8306 11.0106 15.727 11.2516C15.7255 11.2546 15.7226 11.2561 15.7226 11.2606C14.9781 13.0336 13.5795 14.1207 12.0774 14.1207C10.5752 14.1207 9.17666 13.0186 8.43214 11.2606C8.33141 11.018 8.05842 10.9057 7.82339 11.0076C7.81901 11.0091 7.81755 11.0106 7.81317 11.0121L7.76645 11.0345C7.59857 11.0585 7.42923 11.0031 7.30222 10.8893C7.07303 10.6721 6.90515 10.3951 6.82339 10.0866C6.61464 9.42778 6.79128 8.82732 7.08325 8.72699C7.1577 8.70453 7.23653 8.70453 7.31244 8.72699C7.55916 8.79886 7.81609 8.65062 7.88616 8.39756C7.89492 8.36461 7.90076 8.32867 7.90222 8.29423C7.90222 8.0801 7.90222 7.87046 7.90222 7.66382C10.6774 7.41375 13.4701 7.41375 16.2438 7.66382C16.2438 7.87046 16.2438 8.0816 16.2438 8.29723C16.2452 8.56227 16.4554 8.77341 16.7109 8.77041C16.7562 8.77041 16.8014 8.76442 16.8423 8.75095C16.9168 8.72849 16.9956 8.72849 17.0715 8.75095C17.3956 8.82282 17.5693 9.42778 17.3635 10.0866ZM17.1868 7.70275C17.1868 7.52456 17.1868 7.34936 17.1635 7.17266C17.1489 6.94356 16.9795 6.75787 16.7591 6.72942C13.6569 6.41946 10.5343 6.41946 7.43361 6.72942C7.20441 6.75039 7.02485 6.93906 7.01025 7.17266C7.01025 7.34936 7.01025 7.52456 6.9869 7.70574C4.49786 7.46316 3.4497 7.08581 3.10517 6.8627C3.8205 6.38502 7.14456 5.78155 12.0818 5.78155C17.0189 5.78155 20.3445 6.38502 21.0598 6.8627C20.7255 7.08581 19.6656 7.46316 17.1868 7.72671V7.70275Z"
                                                            fill="#23331A" />
                                                        <path
                                                            d="M13.4527 11.2157H10.7198C10.4644 11.2157 10.2556 11.43 10.2556 11.6938C10.2556 11.9576 10.4644 12.1705 10.7198 12.1705H13.4498C13.7052 12.1705 13.9154 11.9576 13.9154 11.6938C13.9154 11.43 13.7052 11.2157 13.4498 11.2157H13.4527Z"
                                                            fill="#23331A" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0">
                                                            <rect width="24" height="24.6178" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 rightContainer__card">
                                <div class="smallCard">
                                    <div class="row">
                                        <div class="col-9">
                                            <p>Avg. Harvest/Farmer</p>
                                            <h4>{{stats ? stats.avgYield : '' | formatNumber }} <small class="smallFont">tons/farmer</small></h4>
                                        </div>
                                        <div class="col-3 d-flex justify-content-end align-content-end">
                                            <div class="rightContainer__card__svg bg__new2">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="#2B700B" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M19.732 12.4545C19.6835 12.4879 19.3487 12.7228 18.8821 13.1003C18.8105 9.60976 17.683 4.854 15.6961 4.854C13.7093 4.854 12.5819 9.6096 12.5103 13.1004C12.0437 12.7226 11.7089 12.4878 11.6605 12.4543L10.4375 11.6058L10.9004 13.0206C10.9059 13.0373 11.4456 14.7098 11.4456 16.7347C11.4456 19.1441 13.0871 21.1041 15.1053 21.1041H16.287C18.3046 21.1041 19.9464 19.1439 19.9464 16.7347C19.9464 14.7098 20.4864 13.0373 20.4915 13.021L20.9584 11.6031L19.732 12.4545ZM13.5142 12.9242C13.5272 12.4771 13.5555 12.0377 13.5978 11.6104H14.3692V10.611H13.7241C13.8041 10.0882 13.903 9.59244 14.0146 9.13071H14.8716V8.13128H14.2924C14.7369 6.73958 15.2837 5.85326 15.6963 5.85326C16.3193 5.85326 17.2497 7.87776 17.6685 10.611H17.3675V11.6104H17.7946C17.8369 12.0375 17.8652 12.4771 17.8782 12.9242H17.0915V13.9236H17.8782C17.8775 13.9409 17.8769 13.9578 17.8765 13.9747C17.0837 14.7158 16.2225 15.6623 15.6961 16.6642C15.1694 15.6621 14.3083 14.7162 13.5157 13.9747C13.5154 13.9578 13.5147 13.9409 13.5141 13.9236H14.0932V12.9242H13.5142ZM18.9471 16.7348C18.9471 18.5931 17.7541 20.1049 16.2871 20.1049H15.1055C13.6385 20.1049 12.4452 18.5931 12.4452 16.7348C12.4452 15.7412 12.3281 14.8363 12.1973 14.1367C13.5152 15.2562 15.1966 17.013 15.1966 18.4415H16.196C16.196 17.013 17.877 15.2562 19.195 14.1367C19.0645 14.8361 18.9471 15.7412 18.9471 16.7348Z"
                                                         />
                                                    <path d="M16.8705 8.13135H15.8711V9.13077H16.8705V8.13135Z"  />
                                                    <path d="M16.3681 10.6108H15.3687V11.6103H16.3681V10.6108Z"  />
                                                    <path d="M16.0922 12.9241H15.0928V13.9235H16.0922V12.9241Z"  />
                                                    <path
                                                        d="M7.6242 5.74994L8.80585 4.56829L8.09926 3.8617L7.00772 4.95323V2.89575H6.00829V4.95323L4.91642 3.86103L4.20983 4.56762L5.39765 5.75577C3.7401 6.18036 3.0415 7.70348 3.0415 10.7119C3.0415 12.7394 3.37465 15.0246 3.93299 16.8246C4.40172 18.3363 5.22908 20.1386 6.50801 20.1385C7.78694 20.1385 8.61396 18.3362 9.08236 16.8244C9.6407 15.0243 9.97351 12.7396 9.97351 10.7121C9.97384 8.71423 9.66119 7.40732 8.98974 6.59978C8.59114 6.12039 8.10825 5.8742 7.6242 5.74994ZM8.12774 16.5286C7.56889 18.3319 6.91127 19.1391 6.50784 19.1391C6.10407 19.1391 5.44662 18.3319 4.88727 16.5286C4.41588 15.0076 4.11389 13.1194 4.05275 11.36H5.34468V10.3606H4.04459C4.05176 10.0378 4.06891 9.7448 4.09406 9.47546H6.11706V8.47603H4.25047C4.68439 6.6311 5.7093 6.62877 6.50801 6.62843C7.36435 6.62843 7.86073 6.8055 8.22119 7.23875C8.7209 7.8399 8.97425 9.00856 8.97408 10.7121C8.97408 12.6443 8.65777 14.8189 8.12774 16.5286Z"
                                                         />
                                                    <path d="M6.97999 10.3604H5.96924V11.3598H6.97999V10.3604Z"  />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        

                        <!-- Calender -->
                        <article class="margin_top_lg">
                            <div class="offtaker_map" id="offtaker_map"></div>
                            
                        </article>

                        <!-- Recent Offers -->
                        <div class="offtaker py-0 px-4 margin_top_lg">
                            <div class="">
                                <div class="row margin_top_sm">
                                    
                                    <div class="dashboardOrders" style="width: 100%">
                                        <div class="row dashboardOrders__container margin_bottom_md">
                                            <div class="col-6">
                                                <h4 class="font-sm caps_upper font-bold">RECENT ORDERS</h4>
                                            </div>
                                            <div class="col-6 text-right pr-0">
                                                <router-link :to="{ name: 'offtaker.profile'}" class="text__primary">View all</router-link>
                                            </div>
                                        </div>
                                    
                                        <div class="dashboardOrders__body">
                                            <Orders :orders="orders" :gettingOrders="gettingOrders" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
  </div>
</template>

<script>
import CropRow from '@/components/off-taker/dashboard/CropRow';
import Orders from '@/components/off-taker/dashboard/Orders';
import moment from 'moment';
import { mapState } from 'vuex';

export default {
    data() {
        return {
            moment,
            crops: [],
            offtakerCrops: [],
            gettingOfftakerCrops: false,
            gettingOrders: false,
            gettingCrops: false,
            loadingStatistics: false,
            stats: '',
            locations: [],
            orders: []
        }
    },
    computed: {
        ...mapState(['user']),
    },
    methods: {

        getCrops() {
            this.$http.get("off_takers/crops?pageSize=5")
            .then(({ data }) => {
                this.crops = [...data.items];
                // console.log(this.crops)
                // this.initMap()
                this.getOfftakerCrops()
            })
            .catch(err => {
                this.$toastr.error(err);
            });
        },
        getOfftakerCrops() {
            this.gettingOfftakerCrops = true;
            this.$http.get("off_takers/farm_crops")
            .then(({ data }) => {
                this.$log('Offtaker crops ', data)
                this.offtakerCrops = [...data.items];
                this.offtakerCrops.map(item => {
                    item.currentStage = this.getCurrentStage(item);
                    return item;
                });
                this.setCropsLocations()
                this.initMap()
            })
            .catch(err => {
                this.$toastr.error(err);
            })
            .finally(() => {
                this.gettingOfftakerCrops = false;
            })
        },
        getStats() {
        this.loadingStatistics = true;
        this.$http.get("statistics")
            .then(response => {
                this.$log("stats", response);
                this.stats = response.data;
            })
            .catch(error => {
                this.$toastr.error(error);
            })
            .finally(() => {
                this.loadingStatistics = false;
            });
        },
        initMap() {
            console.log({ lat: this.getAvLat(), lng: this.getAvtLng() });
            const map = new google.maps.Map(document.getElementById("offtaker_map"), {
                center: { lat: this.getAvLat(), lng: this.getAvtLng() },
                zoom: 6
            });
            const image = `${this.$baseImageUrl}/farmTag.svg`;
            const infoWindow = new google.maps.InfoWindow();
            const mark = this.locations.forEach((location, i) => {
                var marker = new google.maps.Marker({
                    position: { lat: location.lat, lng: location.lng },
                    map: map,
                    icon: image,
                    zIndex: location.zIndex
                });
                marker.addListener('click', function() {
                    infoWindow.setContent(location.description);
                    infoWindow.open(map, marker);
                });
                
            });
        },
        getAvLat() {
            if (this.locations.length === 0) {
                return 6.45407;
            }
            let total = 0;
            this.locations.forEach(item => {
                total += item.lat;
            });
            return total / this.locations.length;
        },
        getAvtLng() {
            if (this.locations.length === 0) {
                return 3.39467;
            }
            let total = 0;
            this.locations.forEach(item => {
                total += item.lng;
            });
            return total / this.locations.length;
        },
        setCropsLocations() {
            this.offtakerCrops.filter((item, index) => {
                const info = `
                    <div class="">
                        <div class="crop-map__container ">
                            
                            <div class="crop-map__container__img">
                                <img src="${item.images && item.images[0] && item.images[0].url ? item.images[0].url : ''}" />
                                <div class="crop-map__container__img__caption">
                                <h4><i class="naira"></i> ${(item.kg_price / 0.001).toLocaleString() } <small class="smallFont">per ton</small></h4>
                                </div>
                            </div>
                        
                            <div class="crop-map__container__content">
                                <div class="row margin_bottom_md">
                                    <div class="col-6">
                                        <h5 class="font-sm font-bold">${item.name}</h5>
                                    </div>
                                    <div class="col-6">
                                        <p class="smallFont">${(item.kg_yield / 1000).toLocaleString()} ton(s)</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <p class="smallFont font-xs">Farming stage</p>
                                        <h4 class="font-bold font-sm">${item.currentStage.name}</h4>
                                    </div>
                                    <div class="col-6">
                                        <a href="http://localhost:8080/offtaker/crop/${item.id}" 
                                        class="btn btn-sm btn-secondary-outline px-2 py-2">View Details</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                `;
                const { farm } = item;
                if (farm.longitude !== null && farm.latitude !== null) {
                    this.locations.push({
                        lat: farm.latitude,
                        lng: farm.longitude,
                        description: info,
                        zIndex: index + 20
                    });
                }
                
            });
        },
        getOrders() {
            this.gettingOrders = true;
            this.$http.get('crop_orders?pageSize=5')
            .then((response) => {
                this.orders = response.data.items
                this.$log(response.data)
            })
            .catch((error) => {
                this.$toastr.error(error)
            })
            .finally(() => {
                this.gettingOrders = false
            })
        },
        getCurrentStage(crop) {
            const totalStages = crop.stages.length;
            let totalWeeks = 0;
            let currentStage = null;
            crop.stages.forEach((stage, i) => {
                let startDate = this.moment(crop.date_planted).add(totalWeeks, "weeks").unix();
                totalWeeks += stage.no_of_weeks;
                let endDate = this.moment(crop.date_planted).add(totalWeeks, "weeks").unix();
                let currentTime = this.moment().unix();
                if((currentTime > startDate && currentTime < endDate ) || (!currentStage && i === totalStages - 1) ) {
                    currentStage = stage;
                }
            });
            return currentStage;
        },
    },
    created() {
        this.getCrops()
        this.getStats()
        this.getOrders()
    },
    components: {
        CropRow,
        Orders
    }
}
</script>

<style scoped>
    .harvest--due {
        background: rgba(242, 171, 62, 0.25);
        border-radius: 15px;
        padding: 15px 24px;
        margin-top: 20px;
    }
    .harvest--due--text {
        margin-left: 10px;
    }
    .harvest--due--text p:last-child {
        font-size: 16px;
        line-height: 22px;
        color: #23331a;
        margin: 0;
        padding: 0;
    }
</style>